import { aviary } from "@aviary";
import { sharedUS } from "@shared/locales";

import { brandsPage } from "./brandsPage";
import { catalog } from "./catalog";
import { common } from "./common";
import { error } from "./error";
import { footer } from "./footer";
import { getFullscript } from "./getFullscript";
import { navigation } from "./navigation";
import { productNotFound } from "./productNotFound";
import { search } from "./search";
import { seo } from "./seo";

const US = {
  aviary,
  common,
  navigation,
  footer,
  catalog,
  search,
  error,
  getFullscript,
  brandsPage,
  productNotFound,
  seo,
  ...sharedUS,
};

export { US };
